import { fork, takeEvery, takeLatest } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import { initApp, signOut } from '@lib/actions';
import {
  DISPATCH_FETCH_CUSTOM_WEB_STYLES,
  DISPATCH_PUBLISH_CUSTOM_WEB_STYLES,
  DISPATCH_SAVE_CUSTOM_WEB_STYLES,
  DISPATCH_SAVE_SETTINGS,
  DISPATCH_SIGN_IN,
} from '@lib/actions/actionTypes';
import saga from '@lib/actions/saga';

import fetchPracticeAnalyzerFacilities, {
  sagaFetchPracticeAnalyzerFacilities,
} from 'actions/fetchPracticeAnalyzerFacilities';
import fetchPracticeAnalyzerLinearData, {
  sagaFetchPracticeAnalyzerLinearData,
} from 'actions/fetchPracticeAnalyzerLinearData';
import fetchPracticeAnalyzerMetrcis, { sagaFetchPracticeAnalyzerMetrics } from 'actions/fetchPracticeAnalyzerMetrics';

import sagaFetchCustomWebStyles from './sagaFetchCustomWebStyles';
import sagaInitApp from './sagaInitApp';
import sagaPublishCustomWebStyles from './sagaPublishCustomWebStyles';
import sagaSaveCustomWebStyles from './sagaSaveCustomWebStyles';
import sagaSaveSettings from './sagaSaveSettings';
import sagaSignIn from './sagaSignIn';
import sagaSignOut from './sagaSignOut';
import sagaWatchers from './sagaWatchers';

export default function* rootSaga() {
  yield fork(saga);

  // sagas web-app only
  yield fork(sagaWatchers);
  yield takeLatest(getType(initApp.request), sagaInitApp);
  yield takeLatest(DISPATCH_FETCH_CUSTOM_WEB_STYLES, sagaFetchCustomWebStyles);
  yield takeLatest(DISPATCH_PUBLISH_CUSTOM_WEB_STYLES, sagaPublishCustomWebStyles);
  yield takeLatest(DISPATCH_SAVE_CUSTOM_WEB_STYLES, sagaSaveCustomWebStyles);
  yield takeLatest(DISPATCH_SAVE_SETTINGS, sagaSaveSettings);
  yield takeLatest(DISPATCH_SIGN_IN, sagaSignIn);
  yield takeLatest(getType(signOut), sagaSignOut);
  yield takeEvery(fetchPracticeAnalyzerLinearData.request, sagaFetchPracticeAnalyzerLinearData);
  yield takeEvery(fetchPracticeAnalyzerFacilities.request, sagaFetchPracticeAnalyzerFacilities);
  yield takeEvery(fetchPracticeAnalyzerMetrcis.request, sagaFetchPracticeAnalyzerMetrics);
}
